import {connect} from 'react-redux'

import {
    categoriesFetch,
    videosFetch,
    modelsFetch
} from "../redux/actions"

import Sidebar from '../components/Sidebar'
import SBCategories from '../components/sidebars/Categories'
import ThumbsBlock from '../components/ThumbsBlock'
import TVideo from '../components/thumbs/Video'
import SlideModel from '../components/slides/Model'
import Carousel from '../components/Carousel'
import Page from "../components/Page"
import AdFooter from "../components/ads/Footer"
import Link from "../components/links/RouterLink";
import Outstream from "../components/ads/Outstream";
import Native from "../components/ads/Native";

const ViewAllLink = () => {
    return (
        <div className="header-right">
            <Link route="livecams">
                <strong>View All</strong>
            </Link>
        </div>
    )
}

class Index extends Page {
    constructor(props) {
        super(props)
        this.pagination = this.pagination.bind(this)

    }

    static async getInitialProps({query, store, device}) {
        let watchingCount =  device === 'mobile' ? 5 : 15
        let latestCount = device === 'mobile' ? 20 : 80
        let itemsPerPage = device === 'mobile' ? 20 : 100
        await store.dispatch(categoriesFetch({sort: 'top-rated', c: 89, min_videos: 80}, 'sidebar'))
        await store.dispatch(videosFetch('index', 'watching', {sort: 'watching', c: watchingCount}))
        await store.dispatch(videosFetch('index', 'latest', {sort: 'latest', c: latestCount}))
        await store.dispatch(modelsFetch({sort: 'most-videos', c: 12}, 'index'))

        return {
            itemsPerPage,
            device
        }
    }


    backpage() {
        return {
            route: 'index',
            params: {}
        }
    }

    pageParams(page) {
        return {
            route: 'latest',
            params: {'tf': 'all-time', 'page' : page}
        }
    }


    pagination() {
        return {
            activePage: 1,
            pageParams: this.pageParams,
            totalItems: this.props.latest.total,
            itemsCountPerPage: this.props.itemsPerPage
        }
    }

    render() {
        return (
            <div>
                <Sidebar>
                    <SBCategories cats={this.props.cats.data} />
                </Sidebar>
                <div className="content">
                    <ThumbsBlock title="Videos Being Watched" thumbs={this.props.watching} thumb={TVideo} backpage={this.backpage()} />
                    <Native device={this.props.device}/>
                    <Outstream />
                    <ThumbsBlock title="New Videos" thumbs={this.props.latest} thumb={TVideo} pagination={this.pagination()} backpage={this.backpage()} />
                    <Carousel maxSlides={7} addDots={true} title="Models having most videos" slideType={SlideModel} slides={this.props.models.data}/>
                    <AdFooter device={this.props.device}/>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        cats: state.sidebar.categories,
        ...state.pages.index
    }
}

export default connect(mapStateToProps)(Index)



// WEBPACK FOOTER //
// pages/index.js